import React from "react"
import { HistoricoVersoesContextProvider } from "./context/HistoricoVersoesContextProvider"
import { HistoricoVersoes } from "./HistoricoVersoes"

export function Index() {
    return (
        <HistoricoVersoesContextProvider>
            <HistoricoVersoes />
        </HistoricoVersoesContextProvider>
    )
}
